var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12 0 2.695 8.292h8.718l-7.053 5.125 2.694 8.292L12 16.584l-7.054 5.125 2.694-8.292L.588 8.292h8.718L12.001 0Z",
    fill: "currentColor"
  })));
};
export { SvgStar as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xMi4wMDA1IDBMMTQuNjk0NyA4LjI5MTk5TDIzLjQxMzIgOC4yOTE5OUwxNi4zNTk3IDEzLjQxNjdMMTkuMDUzOSAyMS43MDg3TDEyLjAwMDUgMTYuNTg0TDQuOTQ3MDcgMjEuNzA4N0w3LjY0MTIzIDEzLjQxNjdMMC41ODc4MTEgOC4yOTE5OUw5LjMwNjMyIDguMjkxOTlMMTIuMDAwNSAwWiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";